import { render, staticRenderFns } from "./Waiver.vue?vue&type=template&id=ed13f4b4&scoped=true"
import script from "./Waiver.vue?vue&type=script&lang=ts"
export * from "./Waiver.vue?vue&type=script&lang=ts"
import style0 from "./Waiver.vue?vue&type=style&index=0&id=ed13f4b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed13f4b4",
  null
  
)

export default component.exports